var FavsPage = {
  list: []
};

FavsPage.init = function () {
  $(".favorites .product").each(function (i, element) {
    FavsPage.list.push(new ProductView(element, FavsPage));
  });
};

FavsPage.removeProductFromFavs = function (product) {
  Fav.unFavProduct(product._id, function () {
    Fav.loadFavs(function(resp){
      if(resp.favorites && !resp.favorites.length){
        return window.location.reload();
      }
      FavsPage.removeProductView(product._id);
    });
  });
};

FavsPage.removeProductView = function (productId) {
  $('[data-id="' + productId + '"]').remove();
  for (var i = 0; i < FavsPage.list.length; i++) {
    if (FavsPage.list[i].product._id === productId) {
      FavsPage.list.splice(i, 1);
      break;
    }
  }
};

FavsPage.addProductToCart = function (product) {
  if (product.versionQty > 1) {
    VersionModal.loadModal(product._id, {
      onAddToCart: function (product) {
        Cart.addItems({
          type: product.type,
          product: product.product,
          version: product.version,
          qty: 1
        });
      }
    });
  } else {
    Cart.addItems({
      type: product.type,
      product: product._id,
      version: product.version,
      qty: 1
    });
  }
};

$(FavsPage.init);
